<template>
    <section class="mt-16">
      <v-row>
        <v-col cols="12" offset="0" md="10" offset-md="1">    
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0"
          ></v-breadcrumbs>
    
          <h1 class="primary--text">
            <v-icon color="primary">mdi-truck-delivery</v-icon> <span>Listagem de fornecedores</span>
          </h1>
          
          <div style="position:relative">
            <v-data-table
              :headers="headers"
              :items="items"
              :server-items-length="total"
              :loading="loading"
              :footer-props="tableFooter"
              :options.sync="options"
              class="mt-16"
              locale="pt-pt"
            >

            <template v-slot:item.actions="{item}">
              <v-icon
                  small
                  color="primary"
                  class="mr-2"
                  @click="$router.push('suppliers/' + item.NumContrib)"
              >
                  mdi-eye
              </v-icon>
            </template>
              
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </section>
  </template>
  <script>
  import Suppliers from "@/api/Suppliers.js";
  
  export default {
    components: {
    },
    watch: {
      'options': {
        immediate: false,
        handler () {
          setTimeout(() => {this.searchSuppliers()}, 10);
        },
        deep: true,
      },
    },
    beforeCreate(){
      document.title = "ODC - Listagem de fornecedores";
    },
    data: () => ({      
      headers: [
        {
          text: 'Fornecedor',
          sortable: true,
          value: 'Fornecedor',
        },
        {
          text: 'Nome',
          sortable: true,
          value: 'Nome',
        },
        {
          text: 'NIF',
          sortable: true,
          value: 'NumContrib',
        },
        {
            text: "Opções",
            align: "center",
            value: "actions"
        }
      ],
      items: [],
      total: 0,
      loading: false,
      searching: false,
      toDelete:{
        show: false,
        object: null
      },
      tableFooter: {
        'items-per-page-options': [5, 10, 15, 20],
        'items-per-page-text': "Linhas por página"
      },
      options: {},
      speedDial:false,
      filter: {
      },
    }),
    mounted(){
      let a = true
      if(a) {
        this.$router.push('/forbidden');
      }
  
      if(!this.$store.getters.hasPermission(["super", "fornecedores.read"])) {
        this.$router.push('/admin');
      }
  
      this.fillBaseData();
    },
    methods:{      
      fillBaseData() {
  
        if(localStorage["suppliers-list-" + this.$store.state.user.data.id] != undefined){
  
          let data = JSON.parse(localStorage["suppliers-list-" + this.$store.state.user.data.id]);
  
          this.filter = data.filter;
  
          this.options = data.options;
        }
      },
      searchSuppliers(event){
        if(!!event && event.type == 'submit'){
          this.options.page = 1;
        }
  
        this.loading = true;
  
        let filter = {...this.filter};
  
        let request = {
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          page: this.options.page,
          limit: this.options.itemsPerPage,
        };
      
        Object.assign(request, filter);
  
        localStorage["suppliers-list-" + this.$store.state.user.data.id] = JSON.stringify({
          filter: this.filter,
          options: this.options,
        });
  
        Suppliers.search(request).then(response => {
  
          let data = response.data;
  
          this.total = data.total;
  
          this.items = data.data.map((item) => {
  
            this.searching = false;
  
            return item;
          });
  
          this.loading = false;
  
        });
      },
      resetSuppliers()
      {
        this.filter = {
        };
  
        this.searchSuppliers();
      },
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Listagem de fornecedores',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  